import { createSelector } from '@reduxjs/toolkit';
import { TStoreState } from 'redux/types';
import {
	TSwedBankStore,
	TSwedBankIntegrationResponsePayload,
	TSwedBankSearchInvoicesResponsePayload,
} from './types';

// ==========================================:
const getSwedBankState = (state: TStoreState): TSwedBankStore => state.swedBank;
export const getSwedBank = createSelector(
	[getSwedBankState],
	(swedBank: TSwedBankStore) => swedBank,
);

// ====================================================:
export const getSwedBankIntegrationLoad = createSelector(
	[getSwedBank],
	(swedBank: TSwedBankStore): boolean => swedBank.swedBankIntegrationLoader,
);

// ====================================================:
export const getSwedBankIntegration = createSelector(
	[getSwedBank],
	(swedBank: TSwedBankStore): TSwedBankIntegrationResponsePayload => swedBank.swedBankIntegration,
);

// ====================================================:

export const searchInvoicesLoad = createSelector(
	[getSwedBank],
	(swedBank: TSwedBankStore): boolean => swedBank.searchInvoicesLoader,
);

// ====================================================:

export const searchInvoices = createSelector(
	[getSwedBank],
	(swedBank: TSwedBankStore): TSwedBankSearchInvoicesResponsePayload => swedBank.searchInvoices,
);
